import React from "react";
import { useEffect, useState } from "react";
import { getFileType } from "@/lib/utils/file-utils";
import { FileWithImage } from "./images-gallery.component";

interface FocusedItemProps {
	file: FileWithImage | null;
	onClose: () => void;
	connectedOrganizationId?: string;
	handleShareButtonClick: (file: FileWithImage) => void;
	shareButtonText: (file: FileWithImage) => string;
}

export const FocusedItem = ({
	file,
	onClose,
	connectedOrganizationId,
	handleShareButtonClick,
	shareButtonText,
}: FocusedItemProps) => {
	const [isImage, setIsImage] = useState(false);

	useEffect(() => {
		if (!file || !file.meta_data || !file.file_name) return;
		setIsImage(getFileType(file.meta_data as Record<string, any>, file.file_name) === "img");
	}, [file]);

	return (
		file &&
		isImage && (
			<div
				className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center touch-none flex-col"
				onClick={onClose}
			>
				<div>
					<div className="flex flex-row justify-end">
						<label
							onClick={onClose}
							className="text-blue-600 transition-colors active:text-blue-200 items-center flex"
						>
							Schliessen
						</label>
					</div>
					<div
						className="relative max-w-[95vw] max-h-[95vh] rounded-lg border border-gray-200 shadow-lg"
						onClick={onClose}
					>
						<img
							src={file.image}
							alt={file.file_name || ""}
							className="max-w-full max-h-[90vh] object-contain rounded-lg"
						/>
					</div>
					<div className="flex flex-row justify-center">
						{connectedOrganizationId && (
							<label
								className="text-blue-600 transition-colors active:text-blue-200 items-center flex"
								onClick={async () => {
									if (!file.id) return;
									handleShareButtonClick(file);
								}}
							>
								{shareButtonText(file)}
							</label>
						)}
					</div>
				</div>
			</div>
		)
	);
};
